<template>
  <!-- マスタメンテナンス -->
  <div id="AppMasterMaint">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="width:90%; margin-left: 50px; margin-right: 50px;">
      <label class="searchTitle label">マスタメンテナンス</label>
      <b-tabs type="is-boxed">
        <b-tab-item label="患者DB連携" icon="transfer-right">
          <patientDynamics />
        </b-tab-item>
        <b-tab-item label="動態表" icon="clipboard-plus">
          <deviceDynamics />
        </b-tab-item>
        <b-tab-item label="消耗品発送指示" icon="truck">
          <disposableOrder />
        </b-tab-item>
        <b-tab-item label="得意先情報" icon="account-box">
          <customerInfo />
        </b-tab-item>
        <b-tab-item label="品目情報" icon="clipboard">
          <productInfo />
        </b-tab-item>
        <b-tab-item label="営業所情報" icon="home-variant">
          <officeInfo />
        </b-tab-item>
        <b-tab-item label="役職情報" icon="mdi mdi-card-account-details">
          <positionInfo />
        </b-tab-item>
      </b-tabs>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import deviceDynamicsTemplate from "./AppMasterMaintenanceDeviceDynamics";
import patientDynamicsTemplate from "./AppMasterMaintenancePatientDynamics";
import customerInfoTemplate from "./AppMasterMaintenanceCustomerInfo";
import productInfoTemplate from "./AppMasterMaintenanceProductInfo";
import officeInfoTemplate from "./AppMasterMaintenanceOfficeInfo";
import disposableOrderTemplate from "./AppMasterMaintenaceDisposableOrder";
import positionInfoTemplate from "./AppMasterMaintenancePositionInfo";

export default {
  name: "AppMasterMaint",
  methods: {},
  data() {
    return {};
  },
  filters: {},
  components: {
    deviceDynamics: deviceDynamicsTemplate,
    patientDynamics: patientDynamicsTemplate,
    customerInfo: customerInfoTemplate,
    productInfo: productInfoTemplate,
    officeInfo: officeInfoTemplate,
    disposableOrder: disposableOrderTemplate,
    positionInfo: positionInfoTemplate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppMasterMaint.vue